import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box, Text, TextButton } from '@zillow/constellation';
import { PostsLayout, PostCard } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { getGraphQLData } from '../../graphql/graphql.js';
import { POSTS_BLOCK_QUERY } from '../../graphql/queries/post.js';

var Posts = function Posts(_ref) {
  var attrs = _ref.attrs,
    _ref$blockData = _ref.blockData,
    blockData = _ref$blockData === void 0 ? {} : _ref$blockData;
  var heading = attrs.heading,
    allLink = attrs.allLink,
    _attrs$layout = attrs.layout,
    layout = _attrs$layout === void 0 ? 'GRID' : _attrs$layout,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    _attrs$size = attrs.size,
    size = _attrs$size === void 0 ? 'lg' : _attrs$size,
    _attrs$alignment = attrs.alignment,
    alignment = _attrs$alignment === void 0 ? 'horizontal' : _attrs$alignment;
  var posts = blockData.posts;
  var items = posts.map(function (post) {
    var _post$title, _post$excerpt, _post$categories;
    return {
      id: post === null || post === void 0 ? void 0 : post.id,
      title: post === null || post === void 0 || (_post$title = post.title) === null || _post$title === void 0 ? void 0 : _post$title.raw,
      excerpt: post === null || post === void 0 || (_post$excerpt = post.excerpt) === null || _post$excerpt === void 0 ? void 0 : _post$excerpt.raw,
      loading: loading,
      image: post.featuredImage || undefined,
      category: post.primaryCategory || ((_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories[0]) || undefined,
      readTime: post.readTime,
      url: {
        href: post.link
      }
    };
  });
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      margin: '0 0 $spacing.md 0'
    }
  }, heading && (allLink === null || allLink === void 0 ? void 0 : allLink.link) && /*#__PURE__*/React.createElement(Box, {
    sx: {
      margin: '0 0 $spacing.md 0',
      display: 'flex'
    }
  }, heading && /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: '1 1 0'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    fontColor: "textDarkBlue"
  }, heading)), (allLink === null || allLink === void 0 ? void 0 : allLink.link) && /*#__PURE__*/React.createElement(Box, {
    sx: {
      paddingLeft: '$spacing.xs',
      display: 'flex',
      justifySelf: 'flex-end',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(TextButton, {
    href: allLink.link,
    as: "a",
    iconPosition: "end",
    "aria-label": heading
  }, allLink.text ? allLink.text : 'See all'))), layout !== 'SINGLE' && /*#__PURE__*/React.createElement(PostsLayout, {
    layout: layout,
    items: items
  }), layout === 'SINGLE' && /*#__PURE__*/React.createElement(PostCard, _extends({}, items[0], {
    loading: loading,
    alignment: alignment,
    size: size
  })));
};
Posts.getBlockData = function (_ref2) {
  return new Promise(function ($return, $error) {
    var _data$cmsPosts, attrs, curatedPosts, _attrs$type, type, _attrs$site, site, taxonomy, terms, _attrs$perPage, perPage, _attrs$postType, postType, _attrs$order, order, _attrs$orderby, orderby, options, data;
    attrs = _ref2.attrs;
    curatedPosts = attrs.curatedPosts, _attrs$type = attrs.type, type = _attrs$type === void 0 ? 'query' : _attrs$type, _attrs$site = attrs.site, site = _attrs$site === void 0 ? 'LEARN' : _attrs$site, taxonomy = attrs.taxonomy, terms = attrs.terms, _attrs$perPage = attrs.perPage, perPage = _attrs$perPage === void 0 ? '4' : _attrs$perPage, _attrs$postType = attrs.postType, postType = _attrs$postType === void 0 ? 'POST' : _attrs$postType, _attrs$order = attrs.order, order = _attrs$order === void 0 ? 'DESC' : _attrs$order, _attrs$orderby = attrs.orderby, orderby = _attrs$orderby === void 0 ? 'DATE' : _attrs$orderby;
    options = {
      postType: postType.toUpperCase(),
      site: site
    };
    if (type === 'query') {
      // Build query
      if (taxonomy === 'category') {
        options.taxonomies = [{
          taxonomy: 'CATEGORY',
          ids: terms
        }];
      } else if (taxonomy === 'post_tag') {
        options.taxonomies = [{
          taxonomy: 'POST_TAG',
          ids: terms
        }];
      }
      options.perPage = perPage === null || perPage === void 0 ? void 0 : perPage.toString();
      options.orderby = orderby.toUpperCase();
      options.order = order.toUpperCase();
    } else {
      options.include = (curatedPosts === null || curatedPosts === void 0 ? void 0 : curatedPosts.map(function (curatedPost) {
        return curatedPost.toString();
      })) || [];
      options.orderby = 'INCLUDE';
    }
    return Promise.resolve(getGraphQLData({
      query: POSTS_BLOCK_QUERY,
      variables: options,
      fetchPolicy: 'no-cache'
    })).then(function ($await_1) {
      try {
        data = $await_1;
        return $return({
          posts: (data === null || data === void 0 || (_data$cmsPosts = data.cmsPosts) === null || _data$cmsPosts === void 0 ? void 0 : _data$cmsPosts.posts) || []
        });
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};
Posts.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    heading: PropTypes.string,
    allLink: PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string
    }),
    layout: PropTypes.oneOf(['GRID', 'INLINE', 'MOSAIC'])
  }),
  blockData: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.shape({
        raw: PropTypes.string
      }),
      excerpt: PropTypes.shape({
        raw: PropTypes.string
      }),
      categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        link: PropTypes.string
      })),
      primaryCategory: PropTypes.shape({
        name: PropTypes.string,
        link: PropTypes.string
      }),
      featuredImage: PropTypes.shape({
        mediaDetails: PropTypes.shape({
          sizes: PropTypes.shape({
            large: PropTypes.shape({
              sourceUrl: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number
            }),
            medium: PropTypes.shape({
              sourceUrl: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number
            })
          })
        })
      }),
      readTime: PropTypes.number
    }))
  })
} : {};
var Posts$1 = Posts;

export { Posts$1 as default };
